<template>
  <MessageLayout
    image="./email-cloud.svg"
    altText="token expired"
    title="Sorry!"
  >
    Your email verification link has expired. Click the button below to sign up
    again.
    <template v-slot:action>
      <ElFormItem class="el-form-item--xl-margin">
        <el-button @click="tryAgain">Sign Up</el-button>
      </ElFormItem>
    </template>
  </MessageLayout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import MessageLayout from "@/modules/messages/MessageLayout.vue";
import ResendEmail from "@/modules/ResendEmail.vue";
import { RoutesName } from "@/router";

@Options({
  components: { ResendEmail, MessageLayout },
})
export default class TokenExpired extends Vue {
  tryAgain(): void {
    this.$router.push(RoutesName.SIGNUP);
  }
}
</script>
